export default [
  {
    text: "Закупка",
    align: "left",
    filterable: true,
    sortable: false,
    value: "numberlot",
  },
  {
    text: "Вид гарантии",
    align: "left",
    filterable: true,
    sortable: false,
    value: "zakgar",
    width: "13%",
  },
  // {
  //   text: "Дата итогового протокола",
  //   align: "left",
  //   filterable: true,
  //   value: "date",
  // },
  {
    text: "Параметры гарантии",
    align: "left",
    filterable: true,
    sortable: false,
    value: "bg",
    width: "15%",
  },
  {
    text: `Клиент`,
    align: "left",
    filterable: false,
    sortable: false,
    value: "client_innname",
    width: "20%",
  },
  {
    text: `Заказчик`,
    align: "left",
    filterable: false,
    sortable: false,
    value: "winner_innname",
    width: "20%",
  },
  {
    text: "Выполнен",
    align: "center",
    filterable: false,
    sortable: false,
    value: "user",
    width: "10%",
  },
  {
    text: "Действия",
    align: "left",
    filterable: false,
    sortable: false,
    value: "actions",
  },
]
